import I18n from 'I18n';
import { useMemo } from 'react';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { FolderIcon, FolderOpenIcon } from 'foundations-assets';
import { Spacer } from 'foundations-components/components/Spacer';
import { FOLDER_PROPERTIES } from 'framework-listing-lib/internal/Folders/constants/folders';
import { getParentFolderId } from 'framework-listing-lib/internal/Folders/utils/folders';
import { StyledCountWrapper, StyledFolderNavItemWrapper } from 'framework-listing-lib/internal/Folders/utils/styled';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import NavItemTooltip from './NavItemTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function FolderNavItem({
  selectedAssetCount,
  folder,
  isSelected,
  onClick,
  openFoldersMap,
  selectedAssetFolderId
}) {
  const parentFolderId = getParentFolderId(folder);
  const open = useMemo(() => {
    return parentFolderId in openFoldersMap && openFoldersMap[parentFolderId].includes(folder.objectId);
  }, [folder.objectId, openFoldersMap, parentFolderId]);
  const IconLeft = useMemo(() => {
    if (open) {
      return FolderOpenIcon;
    }
    return FolderIcon;
  }, [open]);
  const totalAssets = useMemo(() => {
    const totalAssetString = getPropertyValue(folder, FOLDER_PROPERTIES.objectCount, '0');
    const totalAssetNum = totalAssetString ? parseInt(totalAssetString, 10) : 0;
    return `${Math.max(totalAssetNum, 0)}`;
  }, [folder]);
  const folderName = getPropertyValue(folder, FOLDER_PROPERTIES.name);
  const shouldDisableText = useMemo(() => {
    if (!selectedAssetFolderId) {
      return false;
    }
    const folderId = getPropertyValue(folder, FOLDER_PROPERTIES.objectId);
    return folderId === selectedAssetFolderId;
  }, [folder, selectedAssetFolderId]);
  return /*#__PURE__*/_jsxs(StyledFolderNavItemWrapper, {
    isSelected: isSelected,
    "data-folder-id": folder.objectId,
    "data-parent-folder-id": parentFolderId,
    "data-test-id": "crm-listing-folder-nav",
    "data-open": open,
    onClick: () => onClick(folder),
    children: [/*#__PURE__*/_jsx(IconLeft, {
      color: shouldDisableText ? 'icon-core-subtle' : 'fill-accent-blue-default',
      size: "400"
    }), /*#__PURE__*/_jsx(Spacer, {
      space: "0",
      marginInlineEnd: "250",
      display: "inline-block"
    }), /*#__PURE__*/_jsx(UIFlex, {
      align: "center",
      children: /*#__PURE__*/_jsx(NavItemTooltip, {
        selectedAssetCount: selectedAssetCount,
        disabled: !shouldDisableText,
        children: /*#__PURE__*/_jsxs(UITruncateString, {
          children: [folderName, /*#__PURE__*/_jsxs(StyledCountWrapper, {
            children: ["(", /* @ts-expect-error: no types */
            I18n.abbreviateNumber(totalAssets), ")"]
          })]
        })
      })
    })]
  });
}